import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  LABEL,
  SECTION,
  ELLIPSE,
  SHAPE,
  IMAGE,
  WRAPPER,
  GROUP,
  LIST,
  INPUT,
  IMAGE_UPLOAD,
  FILE_UPLOAD,
  DATE_PICKER,
  CHECKBOX,
  FORM,
  SELECT,
  ROW,
  COLUMN,
  ROW_SPACER,
  COLUMN_SPACER,
  WEB_VIEW,
  COMPONENT_INSTANCE,
  LIBRARY_COMPONENT,
  LINE,
} from '@adalo/constants'

import { getObjectBinding } from '../utils/dependencies'
import { getVisible } from '../utils/visibility'
import { normalizeAttributes } from '../utils/styles'

import Label from './Label'
import Section from './Section'
import Line from './Line'
import Ellipse from './Ellipse'
import Shape from './Shape'
import Image from './Image'
import Input from './Input'
import ImageUpload from './ImageUpload'
import FileUpload from './FileUpload'
import DatePicker from './DatePicker'
import Select from './Select'
import Checkbox from './Checkbox'
import Form from './Form'
import WebView from './WebView'
import Group from './Group'
import List, { WrappedListItem } from './List'
import Wrapper from './Wrapper'
import Row from './Row'
import Column from './Column'
import RowSpacer from './RowSpacer'
import ColumnSpacer from './ColumnSpacer'
import ComponentInstance from './ComponentInstance'
import LibraryComponent from './LibraryComponent'

const mapping = {
  [LABEL]: Label,
  [SECTION]: Section,
  [LINE]: Line,
  [IMAGE]: Image,
  [ELLIPSE]: Ellipse,
  [SHAPE]: Shape,
  [GROUP]: Group,
  [WRAPPER]: Wrapper,
  [ROW]: Row,
  [COLUMN]: Column,
  [LIST]: List,
  [INPUT]: Input,
  [IMAGE_UPLOAD]: ImageUpload,
  [FILE_UPLOAD]: FileUpload,
  [DATE_PICKER]: DatePicker,
  [CHECKBOX]: Checkbox,
  [FORM]: Form,
  [SELECT]: Select,
  [ROW_SPACER]: RowSpacer,
  [COLUMN_SPACER]: ColumnSpacer,
  [WEB_VIEW]: WebView,
  [COMPONENT_INSTANCE]: ComponentInstance,
  [LIBRARY_COMPONENT]: LibraryComponent,
  listItem: WrappedListItem,
}

export class ObjectRenderer extends Component {
  renderChildren = (children, item) => {
    const { active, component, topScreen, object, listItemId } = this.props

    if (children.filter(c => !c).length > 0) {
      console.log('--------> INFO:', object)
      throw new Error('ENCOUNTERED NULL CHILD!')
    }

    return children.map(child => (
      <WrappedObjectRenderer
        key={child.id}
        object={child}
        component={component}
        active={active}
        topScreen={topScreen}
        listItemId={listItemId || item?.[object.id]?.id}
      />
    ))
  }

  render() {
    let {
      app,
      active,
      topScreen,
      component,
      object,
      bindingData,
      parentBindingData,
      isReusableComponent,
      visible,
      getBinding,
      getParams,
      getApp,
      getFileUploadsBaseURL,
      getImageUploadsBaseURL,
      onEnter,
      setUploading,
      formSubmitSuccess,
      listItemId,
    } = this.props

    if (object.hidden || !visible) {
      return null
    }

    // normalize all object attributes to their desired value
    if (app && app.branding) {
      object.attributes = normalizeAttributes(object.attributes, app.branding)
    }

    let baseProps = {
      isReusableComponent,
      app,
      component,
      object,
      active,
      bindingData,
      parentBindingData,
      topScreen,
      getBinding,
      getParams,
      getApp,
      renderChildren: this.renderChildren,
      getFileUploadsBaseURL,
      getImageUploadsBaseURL,
      onEnter,
      formSubmitSuccess,
      listItemId,
    }

    let ObjectClass = mapping[object.type]

    if (!ObjectClass) {
      console.warn(`I don't know how to render ${object.type}`)

      return null
    }

    if (object.type === IMAGE_UPLOAD) {
      baseProps.setUploading = setUploading
    }

    return (
      <ObjectClass {...baseProps}>
        {object.children ? this.renderChildren(object.children) : null}
      </ObjectClass>
    )
  }
}

const mapStateToProps = (state, props) => {
  let {
    object,
    getBinding,
    getBindingsList,
    getParams,
    getFileUploadsBaseURL,
    getImageUploadsBaseURL,
    getApp,
    listItemId,
  } = props

  return {
    bindingData: getObjectBinding(state, object, {
      getParams,
      getBinding,
      getBindingsList,
      getFileUploadsBaseURL,
      getImageUploadsBaseURL,
      getApp,
      listItemId,
    }),
    visible: getVisible(state, object, {
      getParams,
      getBinding,
      getBindingsList,
      getApp,
    }),
  }
}

const ConnectedObjectRenderer = connect(mapStateToProps)(ObjectRenderer)

export default class WrappedObjectRenderer extends Component {
  static contextTypes = {
    getBinding: PropTypes.func,
    getBindingsList: PropTypes.func,
    getParams: PropTypes.func,
    getApp: PropTypes.func,
    getFileUploadsBaseURL: PropTypes.func,
    getImageUploadsBaseURL: PropTypes.func,
  }

  render() {
    let { getApp } = this.context

    let app = getApp()

    return (
      <ConnectedObjectRenderer {...this.props} {...this.context} app={app} />
    )
  }
}

export class MultipleObjectRenderer extends Component {
  render() {
    let { objects, ...props } = this.props

    return (
      <React.Fragment>
        {objects.map(obj => (
          <WrappedObjectRenderer {...props} key={obj.id} object={obj} />
        ))}
      </React.Fragment>
    )
  }
}
